export default __webpack_public_path__ + "static/media/diamond-cut-4@2x.f2ee7118.jpg";